import Vue from "vue";
import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import store from "@/vuex/store";
import Router from "@/router";
import { ResponseBase } from "@/interfaces";

export default class AxiosInterceptor {
	constructor() {
		this.request();
		this.response();
	}

	protected request() {
		Vue.axios.interceptors.request.use(
			(config: AxiosRequestConfig) => {
				const token: string = store.getters["AppModule/getToken"];
				if (token) {
					config.headers['token'] = token;
				}
				config.headers["Accept"] = "application/json, text/plain, */*";
				config.headers["Content-Type"] = "application/json";
				return config;
			},
			(err: AxiosError) => {
				console.log('axios err', err);
				return Promise.reject(err);
			}
		);
	}

	protected response() {
		Vue.axios.interceptors.response.use(
			async (response: AxiosResponse) => {
				// console.log('responded', response);
				if (response.status === 200 && !response.data.Ok) {
					if (response.data.LoginRequired) {
						store.dispatch("AppModule/setExpiredTokenDialog",true);
					} else {
						store.dispatch("AppModule/setSnackbar", {
							status: "error",
							message:
								(response.data && response.data.Msg) || "Internal server error"
						});

						if (
							response.config.params.action &&
							response.config.params.action === "load"
						) {
							Router.push("/login");
						}
					}
				}
				return response;
			},
			(err: AxiosError) => {

				var msg = err.message;
				if (err.response && err.response.data && err.response.data.Msg)
					msg = err.response.data.Msg;

				/*
				INSTEAD OF DISPLAYING THE ERROR MESSAGE FROM HERE,
				WE'LL BE SENDING A STANDARD RESPONSE
				*/
				// store.dispatch("AppModule/setSnackbar", {
				// 	status: "error",
				// 	message: msg
				// });

				var some : ResponseBase = {
						Ok : false,
						Msg : msg 
				};

				var ar: AxiosResponse = {
					data: some,
					status: 666,
					statusText: msg,
					headers: null,
					config: null,
				};

				return ar;

				return Promise.reject(some);
			}
		);
	}

	protected async delay(): Promise<string> {
		return new Promise(resolve => {
			setTimeout(() => {
				resolve("delay");
			}, 1000);
		});
	}
}
